import { request } from '@/utils/api/request';

import { CHANNEL_ID } from '@/constants/channels';
import { ENDPOINT } from '@/constants/api';

export const ai = {
  generateAltText({ image, signal, shopId, channel, db }) {
    return request.post({
      endpoint: ENDPOINT.WEB_V2,
      payload: { image, shop_id: shopId, channel_id: CHANNEL_ID[channel], db },
      signal,
      url: '/ai/v2/generate-alt-text',
    });
  },
  generateText({ channel, destination, input, operation, signal, shopId, db }) {
    return request.post({
      endpoint: ENDPOINT.WEB_V2,
      payload: {
        channel,
        destination_field: destination,
        input,
        operation,
        shop_id: shopId,
        db,
      },
      signal,
      url: '/ai/v2/product-field-text-generator',
    });
  },
};
